import type { V4HSiteId } from "@/data/common/ids";
import type { CreateSiteSectionProgrammingRangeRequest } from "@/domains/v4b/site-programming-range/site-programming-range.types";
import type { MaybeRefOrGetter } from "vue";

import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { toRef } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SiteProgrammingRangeMutationKeys } from "@/data/api/v4b/site-programming-range/site-programming-range-mutation-keys";
import { SiteProgrammingRangeQueryKeys } from "@/data/api/v4b/site-programming-range/site-programming-range-query-keys";

export function useCreateSiteProgrammingRangeMutation(siteId: MaybeRefOrGetter<V4HSiteId>) {
  const v4b = useServices().v4b.clientSdk;
  const _siteId = toRef(siteId);
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: _siteId.value ? SiteProgrammingRangeMutationKeys.create(_siteId.value) : undefined,
    mutationFn: (command: CreateSiteSectionProgrammingRangeRequest) => {
      if (!_siteId.value) {
        throw new Error("Site ID is required");
      }

      return v4b.siteProgrammingRange.create(_siteId.value, command);
    },
    onSettled: async () => {
      if (!_siteId.value) {
        throw new Error("Site ID is required");
      }

      await queryClient.invalidateQueries({
        queryKey: SiteProgrammingRangeQueryKeys.findPlanning(_siteId.value),
      });
    },
    retry: 0,
  });
}
